import React from "react";

export const SadFaceEmojiSvg = ({ width, height }) => (
  <svg
    width={width ?? "28"}
    height={height ?? "28"}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >

      <path
        d="M18 9C18 13.9705 13.9705 18 9 18C4.03 18 0 13.9705 0 9C0 4.03 4.03 0 9 0C13.9705 0 18 4.03 18 9Z"
        fill="#FFCC4D"
      />
      <path
        d="M5.75 9.00037C6.44036 9.00037 7 8.21686 7 7.25037C7 6.28387 6.44036 5.50037 5.75 5.50037C5.05964 5.50037 4.5 6.28387 4.5 7.25037C4.5 8.21686 5.05964 9.00037 5.75 9.00037Z"
        fill="#664500"
      />
      <path
        d="M12.2507 9.00037C12.9411 9.00037 13.5007 8.21686 13.5007 7.25037C13.5007 6.28387 12.9411 5.50037 12.2507 5.50037C11.5603 5.50037 11.0007 6.28387 11.0007 7.25037C11.0007 8.21686 11.5603 9.00037 12.2507 9.00037Z"
        fill="#664500"
      />
      <path
        d="M4.33338 13.9362C4.42238 14.0167 4.55538 14.0217 4.65088 13.9507C4.67038 13.9362 6.61188 12.5007 9.00088 12.5007C11.3839 12.5007 13.3319 13.9362 13.3509 13.9507C13.4464 14.0217 13.5794 14.0157 13.6684 13.9362C13.7569 13.8562 13.7769 13.7242 13.7154 13.6222C13.6509 13.5152 12.1069 11.0007 9.00088 11.0007C5.89488 11.0007 4.35038 13.5147 4.28638 13.6222C4.22488 13.7247 4.24438 13.8562 4.33338 13.9362Z"
        fill="#664500"
      />

  </svg>
);
